import { lazy, Suspense } from 'react'
import { createBrowserRouter, ScrollRestoration } from 'react-router-dom'

import './App.css'

// ROUTES
const MainRoute = lazy(() => import('./Components/Routes/MainRoute'))
// const SigningRoute = lazy(()=>import('./Components/Routes/SigningRoute'))
const LoggedOutRoutes = lazy(() => import('./Components/Routes/LoggedOutRoutes'))
const AuthWrapper = lazy(() => import('./Components/Auth/AuthWrapper'))
const NotFoundPage = lazy(() => import('./Components/Pages/NotFoundPage'))

const Router = createBrowserRouter([
	{
		path: '/',
		element: <Suspense fallback=''><AuthWrapper /></Suspense>,
		errorElement: <Suspense fallback=''><NotFoundPage /></Suspense>,
		children: [
			// Logged out
			{ path: '/', element: (<><ScrollRestoration /><Suspense fallback=''><LoggedOutRoutes route={'landing'} /></Suspense></>), },
			{ path: '/login', element: (<><ScrollRestoration /><Suspense fallback=''><LoggedOutRoutes route={'login'} /></Suspense></>), },
			{ path: '/signup', element: (<><ScrollRestoration /><Suspense fallback=''><LoggedOutRoutes route={'signup'} /></Suspense></>), },
			{ path: '/about', element: (<><ScrollRestoration /><Suspense fallback=''><LoggedOutRoutes route={'about'} /></Suspense></>), },
			{ path: '/terms', element: (<><ScrollRestoration /><Suspense fallback=''><LoggedOutRoutes route={'terms'} /></Suspense></>), },
			{ path: '/contact', element: (<><ScrollRestoration /><Suspense fallback=''><LoggedOutRoutes route={'contact'} /></Suspense></>), },
			{ path: '/test-form', element: (<><ScrollRestoration /><Suspense fallback=''><LoggedOutRoutes route={'testForm'} /></Suspense></>), },
			{ path: '/test-form-v2', element: (<><ScrollRestoration /><Suspense fallback=''><LoggedOutRoutes route={'testFormV2'} /></Suspense></>), },
			{ path: '/stress-form', element: (<><ScrollRestoration /><Suspense fallback=''><LoggedOutRoutes route={'stressForm'} /></Suspense></>), },
			{ path: '/test-client', element: (<><ScrollRestoration /><Suspense fallback=''><LoggedOutRoutes route={'testClient'} /></Suspense></>), },


			// Logged in routes
			{ path: '/home', element: (<><ScrollRestoration /><Suspense fallback=''><MainRoute route={'home'} /></Suspense></>), },
			{ path: '/calendar', element: (<><ScrollRestoration /><Suspense fallback=''><MainRoute route={'calendar'} /></Suspense></>), },
			{ path: '/schedule', element: (<><ScrollRestoration /><Suspense fallback=''><MainRoute route={'schedule'} /></Suspense></>), },
			{ path: '/client/list', element: (<><ScrollRestoration /><Suspense fallback=''><MainRoute route={'clientList'} /></Suspense></>), },
			{ path: '/client/new', element: (<><ScrollRestoration /><Suspense fallback=''><MainRoute route={'clientEdit'} /></Suspense></>), }, // Creating a new client is an "edit" action
			{ path: '/client/:uid/edit', element: (<><ScrollRestoration /><Suspense fallback=''><MainRoute route={'clientEdit'} /></Suspense></>), }, // Explicit edit route
			{ path: '/client/:uid', element: (<><ScrollRestoration /><Suspense fallback=''><MainRoute route={'clientProfile'} /></Suspense></>), }, // View profile route
			{ path: '/clientSessionUpdate/:uid', element: (<><ScrollRestoration /><Suspense fallback=''><MainRoute route={'clientSessionUpdate'} /></Suspense></>), },
			{ path: '/appointment/:sessionId', element: (<><ScrollRestoration /><Suspense fallback=''><MainRoute route={'appointmentDetails'} /></Suspense></>), },
			{ path: '/notes', element: (<><ScrollRestoration /><Suspense fallback=''><MainRoute route={'notes'} /></Suspense></>), },
			{ path: '/settings', element: (<><ScrollRestoration /><Suspense fallback=''><MainRoute route={'settings'} /></Suspense></>), },
			{ path: '/waitlist', element: (<><ScrollRestoration /><Suspense fallback=''><MainRoute route={'waitlist'} /></Suspense></>), },
			{ path: '/resources', element: (<><ScrollRestoration /><Suspense fallback=''><MainRoute route={'resources'} /></Suspense></>), },
			{ path: '/sessions', element: (<><ScrollRestoration /><Suspense fallback=''><MainRoute route={'sessionList'} /></Suspense></>), },
			{ path: '/invoicing', element: (<><ScrollRestoration /><Suspense fallback=''><MainRoute route={'invoicing'} /></Suspense></>), },




			// Design Bible
			{ path: '/designBible', element: (<><ScrollRestoration /><Suspense fallback=''><LoggedOutRoutes route={'designBible'} /></Suspense></>), },

		],
	}
])

export default Router